import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "电影", to: "/category/电影" },
  { label: "综艺", to: "/category/综艺" },
  { label: "资讯", to: "/news" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const isHome = location.pathname === "/";
  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-movie-2-fill text-lg" />
            </span>
            <span
              className={`font-heading text-xl font-bold tracking-wide ${
                solid ? "text-foreground-950" : "text-white"
              }`}
            >
              爱爱网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const active =
                item.to === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    active
                      ? "text-primary-600"
                      : solid
                        ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                        : "text-white/85 hover:text-white hover:bg-white/10"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={submitSearch}
              className={`hidden lg:flex items-center gap-2 rounded-full px-3 h-9 border transition-colors ${
                solid
                  ? "bg-background-100 border-background-200"
                  : "bg-white/15 border-white/25"
              }`}
            >
              <i
                className={`ri-search-line text-sm ${
                  solid ? "text-foreground-500" : "text-white/80"
                }`}
              />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视或资讯"
                className={`w-36 bg-transparent text-sm outline-none ${
                  solid
                    ? "text-foreground-900 placeholder:text-foreground-400"
                    : "text-white placeholder:text-white/70"
                }`}
              />
            </form>

            <Link
              to="/search"
              className={`lg:hidden w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-800 hover:bg-background-100"
                  : "text-white hover:bg-white/10"
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-800 hover:bg-background-100"
                  : "text-white hover:bg-white/10"
              }`}
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            <form
              onSubmit={submitSearch}
              className="flex items-center gap-2 rounded-full px-4 h-10 bg-background-100 border border-background-200 mb-2"
            >
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视或资讯"
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </form>
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-4 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}